const circleOptions = {
    clickable: false,
    fillColor: '#2563eb',
    fillOpacity: 0.12,
    strokeColor: '#2563eb',
    strokeWeight: 1,
};

const dropTail = (items, length) => {
    while (items.length > length) {
        items.pop().setMap(null);
    }
};

/**
 * Точки и радиусы POI на карте. Не компоненты Vue: у маркеров библиотеки пустой render,
 * и их v-for роняет патч на insertBefore.
 */
export const createPoiPointLayer = (map, { onDragEnd }) => {
    const markers = [];
    const circles = [];

    const sync = (points, draggable) => {
        const list = Array.isArray(points) ? points : [];
        dropTail(markers, list.length);
        dropTail(circles, list.length);

        list.forEach((point, index) => {
            const position = { lat: Number(point.lat), lng: Number(point.lng) };
            const radius = Number(point.radius_m) || 0;

            let circle = circles[index];
            if (!circle) {
                circle = new google.maps.Circle({ map, ...circleOptions });
                circles[index] = circle;
            }
            circle.setCenter(position);
            circle.setRadius(radius);

            let marker = markers[index];
            if (!marker) {
                marker = new google.maps.Marker({ map, label: String(index + 1) });
                marker.addListener('dragend', () => {
                    const next = marker.getPosition();
                    const current = markers.indexOf(marker);
                    if (!next || current < 0) return;
                    onDragEnd(current, { lat: next.lat(), lng: next.lng() });
                });
                markers[index] = marker;
            }
            marker.setPosition(position);
            marker.setLabel(String(index + 1));
            marker.setDraggable(Boolean(draggable));
        });
    };

    return {
        sync,
        destroy() {
            dropTail(markers, 0);
            dropTail(circles, 0);
        },
    };
};
